import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Portfolio Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: '#0d0906',
          color: '#c2a366',
          fontFamily: 'monospace',
          textAlign: 'center',
          padding: '20px'
        }}>
          <h1 style={{ fontSize: '24px', marginBottom: '20px' }}>
            ⚠️ SYSTEM CRASH
          </h1>
          <p style={{ color: '#a89070', marginBottom: '20px' }}>
            Something went wrong. The system needs a reboot.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 30px',
              background: '#6b8e23',
              border: 'none',
              borderRadius: '4px',
              color: '#f5e6c8',
              fontFamily: 'monospace',
              fontSize: '16px',
              cursor: 'pointer'
            }}
          >
            [ REBOOT ]
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
